export default {
  state: {
    isLoader: false,
  },

  mutations: {
    setIsLoader(state, value) {
      state.isLoader = value;
    },
  },
};
